<template>
  <div class="image">
    <video v-if="isVideo" :src="src" muted playsinline v-bind:class="{ bigImage: field.type === 'bigimage', smallImage: field.type === 'smallimage' }"></video>
    <img v-else :src="src" v-bind:class="{ bigImage: field.type === 'bigimage', smallImage: field.type === 'smallimage' }">
  </div>
</template>

<script>
export default {
  name: 'data-table-cell-image',
  props: {
    element: Object,
    field: Object,
  },
  computed: {
    src() {
      return this.element[this.field.value]
    },
    isVideo() {
      return this.element.media_type === 'video' || /\.(mp4|mov|webm|m4v)(\?|$)/i.test(this.src || '')
    }
  }
}
</script>

<style scoped>
.image img,
.image video {
  object-fit: cover;
  height: 58px;
}

.smallImage {
  height: 36px !important;
}

.bigImage {
  width: 268px !important;
  height: auto !important;
}
</style>